import _toConsumableArray from "/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _toArray from "/build/node_modules/@babel/runtime/helpers/esm/toArray.js";
import _asyncToGenerator from "/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(editor),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(writer),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(deleter);

import _regeneratorRuntime from "/build/node_modules/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { useRef, useEffect, memo } from 'react';

function type(_x) {
  return _type.apply(this, arguments);
}

function _type() {
  _type = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(node) {
    var _len,
        args,
        _key,
        _i,
        _args5,
        arg,
        _args6 = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            for (_len = _args6.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = _args6[_key];
            }

            _i = 0, _args5 = args;

          case 2:
            if (!(_i < _args5.length)) {
              _context5.next = 21;
              break;
            }

            arg = _args5[_i];
            _context5.t0 = typeof arg;
            _context5.next = _context5.t0 === 'string' ? 7 : _context5.t0 === 'number' ? 10 : _context5.t0 === 'function' ? 13 : 16;
            break;

          case 7:
            _context5.next = 9;
            return edit(node, arg);

          case 9:
            return _context5.abrupt("break", 18);

          case 10:
            _context5.next = 12;
            return wait(arg);

          case 12:
            return _context5.abrupt("break", 18);

          case 13:
            _context5.next = 15;
            return arg.apply(void 0, [node].concat(args));

          case 15:
            return _context5.abrupt("break", 18);

          case 16:
            _context5.next = 18;
            return arg;

          case 18:
            _i++;
            _context5.next = 2;
            break;

          case 21:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee);
  }));
  return _type.apply(this, arguments);
}

function edit(_x2, _x3) {
  return _edit.apply(this, arguments);
}

function _edit() {
  _edit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(node, text) {
    var overlap;
    return _regeneratorRuntime.wrap(function _callee2$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            overlap = getOverlap(node.textContent, text);
            _context6.next = 3;
            return perform(node, [].concat(_toConsumableArray(deleter(node.textContent, overlap)), _toConsumableArray(writer(text, overlap))));

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee2);
  }));
  return _edit.apply(this, arguments);
}

function wait(_x4) {
  return _wait.apply(this, arguments);
}

function _wait() {
  _wait = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(ms) {
    return _regeneratorRuntime.wrap(function _callee3$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return new Promise(function (resolve) {
              return setTimeout(resolve, ms);
            });

          case 2:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee3);
  }));
  return _wait.apply(this, arguments);
}

function perform(_x5, _x6) {
  return _perform.apply(this, arguments);
}

function _perform() {
  _perform = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(node, edits) {
    var speed,
        _iterator2,
        _step2,
        op,
        _args9 = arguments;

    return _regeneratorRuntime.wrap(function _callee4$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            speed = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : 60;
            _iterator2 = _createForOfIteratorHelper(editor(edits));
            _context8.prev = 2;

            _iterator2.s();

          case 4:
            if ((_step2 = _iterator2.n()).done) {
              _context8.next = 11;
              break;
            }

            op = _step2.value;
            op(node);
            _context8.next = 9;
            return wait(speed + speed * (Math.random() - 0.5));

          case 9:
            _context8.next = 4;
            break;

          case 11:
            _context8.next = 16;
            break;

          case 13:
            _context8.prev = 13;
            _context8.t0 = _context8["catch"](2);

            _iterator2.e(_context8.t0);

          case 16:
            _context8.prev = 16;

            _iterator2.f();

            return _context8.finish(16);

          case 19:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee4, null, [[2, 13, 16, 19]]);
  }));
  return _perform.apply(this, arguments);
}

function editor(edits) {
  var _iterator, _step, _loop;

  return _regeneratorRuntime.wrap(function editor$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _iterator = _createForOfIteratorHelper(edits);
          _context2.prev = 1;
          _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
            var edit;
            return _regeneratorRuntime.wrap(function _loop$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    edit = _step.value;
                    _context.next = 3;
                    return function (node) {
                      return requestAnimationFrame(function () {
                        return node.textContent = edit;
                      });
                    };

                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            }, _loop);
          });

          _iterator.s();

        case 4:
          if ((_step = _iterator.n()).done) {
            _context2.next = 8;
            break;
          }

          return _context2.delegateYield(_loop(), "t0", 6);

        case 6:
          _context2.next = 4;
          break;

        case 8:
          _context2.next = 13;
          break;

        case 10:
          _context2.prev = 10;
          _context2.t1 = _context2["catch"](1);

          _iterator.e(_context2.t1);

        case 13:
          _context2.prev = 13;

          _iterator.f();

          return _context2.finish(13);

        case 16:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked, null, [[1, 10, 13, 16]]);
}

function writer(_ref2) {
  var _ref3,
      text,
      startIndex,
      endIndex,
      _args3 = arguments;

  return _regeneratorRuntime.wrap(function writer$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _ref3 = _toArray(_ref2), text = _ref3.slice(0);
          startIndex = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 0;
          endIndex = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : text.length;

        case 3:
          if (!(startIndex < endIndex)) {
            _context3.next = 8;
            break;
          }

          _context3.next = 6;
          return text.slice(0, ++startIndex).join('');

        case 6:
          _context3.next = 3;
          break;

        case 8:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked2);
}

function deleter(_ref4) {
  var _ref5,
      text,
      startIndex,
      endIndex,
      _args4 = arguments;

  return _regeneratorRuntime.wrap(function deleter$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _ref5 = _toArray(_ref4), text = _ref5.slice(0);
          startIndex = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : 0;
          endIndex = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : text.length;

        case 3:
          if (!(endIndex > startIndex)) {
            _context4.next = 8;
            break;
          }

          _context4.next = 6;
          return text.slice(0, --endIndex).join('');

        case 6:
          _context4.next = 3;
          break;

        case 8:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked3);
}

function getOverlap(start, _ref6) {
  var _ref7 = _toArray(_ref6),
      end = _ref7.slice(0);

  return [].concat(_toConsumableArray(start), [NaN]).findIndex(function (char, i) {
    return end[i] !== char;
  });
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".styles_typicalWrapper__1_Uvh::after {\n  content: \"|\";\n  animation: styles_blink__2CKyC 1s infinite step-start;\n}\n\n@keyframes styles_blink__2CKyC {\n  50% { opacity: 0; }\n}";
var styles = {
  "typicalWrapper": "styles_typicalWrapper__1_Uvh",
  "blink": "styles_blink__2CKyC"
};
styleInject(css);

var toConsumableArray = function toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var Typical = function Typical(_ref) {
  var steps = _ref.steps,
      loop = _ref.loop,
      className = _ref.className,
      _ref$wrapper = _ref.wrapper,
      wrapper = _ref$wrapper === undefined ? "p" : _ref$wrapper;
  var typicalRef = useRef(null);
  var Component = wrapper;
  var classNames = [styles.typicalWrapper];

  if (className) {
    classNames.unshift(className);
  }

  useEffect(function () {
    if (loop === Infinity) {
      type.apply(undefined, [typicalRef.current].concat(toConsumableArray(steps), [type]));
    } else if (typeof loop === "number") {
      type.apply(undefined, [typicalRef.current].concat(toConsumableArray(Array(loop).fill(steps).flat())));
    } else {
      type.apply(undefined, [typicalRef.current].concat(toConsumableArray(steps)));
    }
  });
  return React.createElement(Component, {
    ref: typicalRef,
    className: classNames.join(' ')
  });
};

var index = memo(Typical);
export default index;